/* istanbul ignore file */
import { FormRow, FormSection } from 'framework/ui/layout';
import { TextInput, DateInput, ClearAfterUnmountWrapper } from 'framework/form';
import FeedbackOnBehalfOfDropdown, {
  FEEDBACK_ON_BEHALF_OF_ALIAS,
} from 'domain/people/feedback/instantFeedback/input/OnBehalfOfDropdown';
import FeedbackAuthorCheckboxesForm from 'domain/people/feedback/instantFeedback/input/FeedbackAuthorCheckboxesForm';
import FeedbackObtainedDropdown from 'domain/people/feedback/instantFeedback/input/ObtainedDropdown';
import ShareInstantFeedbackToggle from 'domain/people/feedback/instantFeedback/input/ShareInstantFeedbackToggle';
import { NotDismissedEmployeeInput } from 'domain/shared/employee';
import EvaluationDetailsForm from 'domain/people/feedback/instantFeedback/input/EvaluationDetailsForm';
import CalendarRightDateInput from 'domain/people/employee/Timeline/feedback/shared/input/CalendarRightDateInput';
import { Typography } from '@mui/material';

interface InstantFeedbackFormProps {
  isPageForm?: boolean;
}

const InstantFeedbackForm = ({ isPageForm }: InstantFeedbackFormProps) => {
  const periodInputs = [
    <DateInput key="date-from" source="relatedPeriodStart" label="Related period from" />,
    <CalendarRightDateInput key="date-to" source="relatedPeriodEnd" label="Related period to" />,
  ];

  return (
    <>
      <Typography variant="body1" mb={2}>
        Fill the form to share feedback about any person at Syberry.
        <br />
        You can praise your colleague or suggest what they can improve.
      </Typography>
      <Typography variant="body1" mb={2}>
        Keep feedback objective and based on facts. We will use the feedback to evaluate colleague&apos;s performance.
      </Typography>
      <FormSection hasEqualPadding title="Feedback Details">
        <FormRow colMd={12} colXl={isPageForm ? 3 : 12}>
          <NotDismissedEmployeeInput
            source="employeeId"
            label="Colleague's name"
            nameSource="sourceEmployeeName"
            includeContractors
            includeInterns
          />
          {isPageForm ? (
            (periodInputs as any)
          ) : (
            <FormRow colMd={6} colXl={6}>
              {periodInputs}
            </FormRow>
          )}
        </FormRow>
        <FormRow colMd={12} colXl={isPageForm ? 3 : 12}>
          <TextInput source="relatedProject" label="What project(s) did colleague work on?" />
          <FeedbackOnBehalfOfDropdown source="onBehalfOf" label="On behalf of" />
          <ClearAfterUnmountWrapper
            isVisible={data => data.onBehalfOf === FEEDBACK_ON_BEHALF_OF_ALIAS.ANOTHER_EMPLOYEE}
          >
            <NotDismissedEmployeeInput
              source="onBehalfOfEmployee"
              label="Another colleague"
              nameSource="onBehalfOfEmployee"
              includeContractors
              includeInterns
            />
          </ClearAfterUnmountWrapper>
          <ClearAfterUnmountWrapper isVisible={data => data.onBehalfOf === FEEDBACK_ON_BEHALF_OF_ALIAS.EXTERNAL_USER}>
            <TextInput source="externalEmployee" label="External user" />
          </ClearAfterUnmountWrapper>
          <ClearAfterUnmountWrapper
            isVisible={data =>
              data.onBehalfOf === FEEDBACK_ON_BEHALF_OF_ALIAS.EXTERNAL_USER ||
              data.onBehalfOf === FEEDBACK_ON_BEHALF_OF_ALIAS.ANOTHER_EMPLOYEE
            }
          >
            <FeedbackObtainedDropdown source="obtainedBy" label="How the feedback was obtained?" />
          </ClearAfterUnmountWrapper>
        </FormRow>
      </FormSection>
      <FormSection
        hasEqualPadding
        title="Evaluation Details"
        subtitle="Provide detailed feedback about your colleague's work and performance"
        isLargeTooltip
      >
        <EvaluationDetailsForm source="feedbackGrades.GENERAL" isPageForm={true} />
      </FormSection>
      <FormSection hasEqualPadding>
        <ShareInstantFeedbackToggle source="isSharedWithEmployee" />
      </FormSection>
      <FormSection hasEqualPadding title="Before submitting feedback" subtitle="Select all that apply">
        <FeedbackAuthorCheckboxesForm />
      </FormSection>
    </>
  );
};

export default InstantFeedbackForm;
